// This file is auto-generated by @hey-api/openapi-ts

import { client } from './client.gen.js';
import type { Client, ClientMeta, Options as Options2, RequestResult, TDataShape } from './client/index.js';
import type { ChangeLogQueryData, ChangeLogQueryErrors, ChangeLogQueryResponses, DataRequestActionApproveData, DataRequestActionApproveErrors, DataRequestActionApproveResponses, DataRequestActionRejectData, DataRequestActionRejectErrors, DataRequestActionRejectResponses, DataRequestHostData, DataRequestHostErrors, DataRequestHostResponses, DataRequestListData, DataRequestListErrors, DataRequestListResponses, HotelActionAddProblemData, HotelActionAddProblemErrors, HotelActionAddProblemResponses, HotelActionStatusesData, HotelActionStatusesErrors, HotelActionStatusesResponses, HotelGetStatusData, HotelGetStatusErrors, HotelGetStatusResponses, HotelSettingGetChangeLogData, HotelSettingGetChangeLogErrors, HotelSettingGetChangeLogResponses, HotelSettingGetSettingsData, HotelSettingGetSettingsErrors, HotelSettingGetSettingsResponses, HotelSettingQueryData, HotelSettingQueryErrors, HotelSettingQueryResponses, HotelSettingQueryShoppingData, HotelSettingQueryShoppingErrors, HotelSettingQueryShoppingResponses, HotelSettingSaveData, HotelSettingSaveErrors, HotelSettingSaveResponses, JobActionAsAppendLearnData, JobActionAsAppendLearnErrors, JobActionAsAppendLearnResponses, JobActionAsRestrictionShopData, JobActionAsRestrictionShopErrors, JobActionAsRestrictionShopResponses, JobActionEnqueueData, JobActionEnqueueEnqueuerData, JobActionEnqueueEnqueuerErrors, JobActionEnqueueEnqueuerResponses, JobActionEnqueueErrors, JobActionEnqueueHotelData, JobActionEnqueueHotelErrors, JobActionEnqueueHotelResponses, JobActionEnqueueResponses, JobActionRetryData, JobActionRetryErrors, JobActionRetryResponses, JobActionTerminateData, JobActionTerminateErrors, JobActionTerminateResponses, LocationGetStatusData, LocationGetStatusErrors, LocationGetStatusResponses, OrganizationActionBulkSaveData, OrganizationActionBulkSaveErrors, OrganizationActionBulkSaveResponses, OrganizationActionProvisionData, OrganizationActionProvisionErrors, OrganizationActionProvisionResponses, OrganizationActionSaveData, OrganizationActionSaveErrors, OrganizationActionSaveResponses, OrganizationGetChangeLogData, OrganizationGetChangeLogErrors, OrganizationGetChangeLogResponses, OrganizationGetData, OrganizationGetErrors, OrganizationGetResponses, OrganizationInsertData, OrganizationInsertErrors, OrganizationInsertResponses, OrganizationLimitGetChangeLogData, OrganizationLimitGetChangeLogErrors, OrganizationLimitGetChangeLogResponses, OrganizationLimitGetSettingsData, OrganizationLimitGetSettingsErrors, OrganizationLimitGetSettingsResponses, OrganizationLimitQueryData, OrganizationLimitQueryErrors, OrganizationLimitQueryResponses, OrganizationLimitSaveData, OrganizationLimitSaveErrors, OrganizationLimitSaveResponses, OrganizationQueryData, OrganizationQueryErrors, OrganizationQueryResponses, OrganizationSaveData, OrganizationSaveErrors, OrganizationSaveResponses, RateScrapeMetadataActionAddProblemData, RateScrapeMetadataActionAddProblemErrors, RateScrapeMetadataActionAddProblemResponses, RateScrapeMetadataActionBulkSaveData, RateScrapeMetadataActionBulkSaveErrors, RateScrapeMetadataActionBulkSaveResponses, RateScrapeMetadataActionCachedShoppingMetricsData, RateScrapeMetadataActionCachedShoppingMetricsErrors, RateScrapeMetadataActionCachedShoppingMetricsResponses, RateScrapeMetadataActionClearData, RateScrapeMetadataActionClearErrors, RateScrapeMetadataActionClearResponses, RateScrapeMetadataActionPromoteData, RateScrapeMetadataActionPromoteErrors, RateScrapeMetadataActionPromoteResponses, RateScrapeMetadataActionPropagateSharedData, RateScrapeMetadataActionPropagateSharedErrors, RateScrapeMetadataActionPropagateSharedResponses, RateScrapeMetadataGetChangeLogData, RateScrapeMetadataGetChangeLogErrors, RateScrapeMetadataGetChangeLogResponses, RateScrapeMetadataGetData, RateScrapeMetadataGetErrors, RateScrapeMetadataGetResponses, RateScrapeMetadataQueryData, RateScrapeMetadataQueryErrors, RateScrapeMetadataQueryResponses, RateScrapeMetadataSaveData, RateScrapeMetadataSaveErrors, RateScrapeMetadataSaveResponses, SessionDeleteData, SessionDeleteErrors, SessionDeleteResponses, SessionNewSessionData, SessionNewSessionErrors, SessionNewSessionResponses, SessionQueryData, SessionQueryErrors, SessionQueryResponses, SharedRateScrapeMetadataActionPropagateData, SharedRateScrapeMetadataActionPropagateErrors, SharedRateScrapeMetadataActionPropagateResponses, SharedRateScrapeMetadataActionStatsData, SharedRateScrapeMetadataActionStatsErrors, SharedRateScrapeMetadataActionStatsResponses, SharedRateScrapeMetadataGetChangeLogData, SharedRateScrapeMetadataGetChangeLogErrors, SharedRateScrapeMetadataGetChangeLogResponses, SharedRateScrapeMetadataGetData, SharedRateScrapeMetadataGetErrors, SharedRateScrapeMetadataGetResponses, SharedRateScrapeMetadataSaveData, SharedRateScrapeMetadataSaveErrors, SharedRateScrapeMetadataSaveResponses, SystemValueActionGetCacheData, SystemValueActionGetCacheErrors, SystemValueActionGetCacheResponses, SystemValueActionQueryAllData, SystemValueActionQueryAllErrors, SystemValueActionQueryAllResponses, SystemValueActionReloadData, SystemValueActionReloadErrors, SystemValueActionReloadResponses, SystemValueSaveData, SystemValueSaveErrors, SystemValueSaveResponses, UserGetChangeLogData, UserGetChangeLogErrors, UserGetChangeLogResponses, UserGetData, UserGetErrors, UserGetResponses, UserQueryData, UserQueryErrors, UserQueryResponses } from './types.gen.js';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Query multiple change log rows.
 */
export const changeLogQuery = <ThrowOnError extends boolean = false>(options: Options<ChangeLogQueryData, ThrowOnError>): RequestResult<ChangeLogQueryResponses, ChangeLogQueryErrors, ThrowOnError> => (options.client ?? client).get<ChangeLogQueryResponses, ChangeLogQueryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/change_logs',
    ...options
});

/**
 * Query the proposed requests
 */
export const dataRequestList = <ThrowOnError extends boolean = false>(options?: Options<DataRequestListData, ThrowOnError>): RequestResult<DataRequestListResponses, DataRequestListErrors, ThrowOnError> => (options?.client ?? client).get<DataRequestListResponses, DataRequestListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/data_requests',
    ...options
});

/**
 * Propose a data request
 */
export const dataRequestHost = <ThrowOnError extends boolean = false>(options: Options<DataRequestHostData, ThrowOnError>): RequestResult<DataRequestHostResponses, DataRequestHostErrors, ThrowOnError> => (options.client ?? client).post<DataRequestHostResponses, DataRequestHostErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/data_requests',
    ...options
});

/**
 * Approve the given request
 */
export const dataRequestActionApprove = <ThrowOnError extends boolean = false>(options: Options<DataRequestActionApproveData, ThrowOnError>): RequestResult<DataRequestActionApproveResponses, DataRequestActionApproveErrors, ThrowOnError> => (options.client ?? client).put<DataRequestActionApproveResponses, DataRequestActionApproveErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/data_requests/{id}/actions/approve',
    ...options
});

/**
 * Reject the given request for the given reason
 */
export const dataRequestActionReject = <ThrowOnError extends boolean = false>(options: Options<DataRequestActionRejectData, ThrowOnError>): RequestResult<DataRequestActionRejectResponses, DataRequestActionRejectErrors, ThrowOnError> => (options.client ?? client).put<DataRequestActionRejectResponses, DataRequestActionRejectErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/data_requests/{id}/actions/reject',
    ...options
});

/**
 * Return the status of multiple hotels, the results are sorted by id
 */
export const hotelActionStatuses = <ThrowOnError extends boolean = false>(options: Options<HotelActionStatusesData, ThrowOnError>): RequestResult<HotelActionStatusesResponses, HotelActionStatusesErrors, ThrowOnError> => (options.client ?? client).get<HotelActionStatusesResponses, HotelActionStatusesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/hotels/actions/statuses',
    ...options
});

/**
 * Record a usage problem with a hotel field
 */
export const hotelActionAddProblem = <ThrowOnError extends boolean = false>(options: Options<HotelActionAddProblemData, ThrowOnError>): RequestResult<HotelActionAddProblemResponses, HotelActionAddProblemErrors, ThrowOnError> => (options.client ?? client).patch<HotelActionAddProblemResponses, HotelActionAddProblemErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/hotels/{id}/actions/add_problem',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Return the status of the hotel
 */
export const hotelGetStatus = <ThrowOnError extends boolean = false>(options: Options<HotelGetStatusData, ThrowOnError>): RequestResult<HotelGetStatusResponses, HotelGetStatusErrors, ThrowOnError> => (options.client ?? client).get<HotelGetStatusResponses, HotelGetStatusErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/hotels/{id}/status',
    ...options
});

/**
 * Query multiple settings
 */
export const hotelSettingQuery = <ThrowOnError extends boolean = false>(options?: Options<HotelSettingQueryData, ThrowOnError>): RequestResult<HotelSettingQueryResponses, HotelSettingQueryErrors, ThrowOnError> => (options?.client ?? client).get<HotelSettingQueryResponses, HotelSettingQueryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/hotels_settings',
    ...options
});

/**
 * Query HotelSettings that have any shopping option enabled
 */
export const hotelSettingQueryShopping = <ThrowOnError extends boolean = false>(options?: Options<HotelSettingQueryShoppingData, ThrowOnError>): RequestResult<HotelSettingQueryShoppingResponses, HotelSettingQueryShoppingErrors, ThrowOnError> => (options?.client ?? client).get<HotelSettingQueryShoppingResponses, HotelSettingQueryShoppingErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/hotels_settings/query_shopping',
    ...options
});

/**
 * Get settings
 */
export const hotelSettingGetSettings = <ThrowOnError extends boolean = false>(options: Options<HotelSettingGetSettingsData, ThrowOnError>): RequestResult<HotelSettingGetSettingsResponses, HotelSettingGetSettingsErrors, ThrowOnError> => (options.client ?? client).get<HotelSettingGetSettingsResponses, HotelSettingGetSettingsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/hotels_settings/{id}',
    ...options
});

/**
 * Save settings
 */
export const hotelSettingSave = <ThrowOnError extends boolean = false>(options: Options<HotelSettingSaveData, ThrowOnError>): RequestResult<HotelSettingSaveResponses, HotelSettingSaveErrors, ThrowOnError> => (options.client ?? client).patch<HotelSettingSaveResponses, HotelSettingSaveErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/hotels_settings/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Load the settings change log for an id
 */
export const hotelSettingGetChangeLog = <ThrowOnError extends boolean = false>(options: Options<HotelSettingGetChangeLogData, ThrowOnError>): RequestResult<HotelSettingGetChangeLogResponses, HotelSettingGetChangeLogErrors, ThrowOnError> => (options.client ?? client).get<HotelSettingGetChangeLogResponses, HotelSettingGetChangeLogErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/hotels_settings/{id}/change_log',
    ...options
});

/**
 * Enqueue the learning message again, with the appendLearn indicator set
 */
export const jobActionAsAppendLearn = <ThrowOnError extends boolean = false>(options: Options<JobActionAsAppendLearnData, ThrowOnError>): RequestResult<JobActionAsAppendLearnResponses, JobActionAsAppendLearnErrors, ThrowOnError> => (options.client ?? client).post<JobActionAsAppendLearnResponses, JobActionAsAppendLearnErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/jobs/actions/as_append_learn',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Enqueue the shopping message again, with a restriction level set
 */
export const jobActionAsRestrictionShop = <ThrowOnError extends boolean = false>(options: Options<JobActionAsRestrictionShopData, ThrowOnError>): RequestResult<JobActionAsRestrictionShopResponses, JobActionAsRestrictionShopErrors, ThrowOnError> => (options.client ?? client).post<JobActionAsRestrictionShopResponses, JobActionAsRestrictionShopErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/jobs/actions/as_restriction_shop',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Manually enqueue a simple message
 */
export const jobActionEnqueue = <ThrowOnError extends boolean = false>(options: Options<JobActionEnqueueData, ThrowOnError>): RequestResult<JobActionEnqueueResponses, JobActionEnqueueErrors, ThrowOnError> => (options.client ?? client).post<JobActionEnqueueResponses, JobActionEnqueueErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/jobs/actions/enqueue',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Manually enqueue an enqueuer job
 */
export const jobActionEnqueueEnqueuer = <ThrowOnError extends boolean = false>(options: Options<JobActionEnqueueEnqueuerData, ThrowOnError>): RequestResult<JobActionEnqueueEnqueuerResponses, JobActionEnqueueEnqueuerErrors, ThrowOnError> => (options.client ?? client).post<JobActionEnqueueEnqueuerResponses, JobActionEnqueueEnqueuerErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/jobs/actions/enqueue_enqueuer',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Enqueue a hotel/site/[day] message for lambda consumption
 */
export const jobActionEnqueueHotel = <ThrowOnError extends boolean = false>(options: Options<JobActionEnqueueHotelData, ThrowOnError>): RequestResult<JobActionEnqueueHotelResponses, JobActionEnqueueHotelErrors, ThrowOnError> => (options.client ?? client).post<JobActionEnqueueHotelResponses, JobActionEnqueueHotelErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/jobs/actions/enqueue_hotel',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Enqueue the message again after incrementing the retry parameter
 */
export const jobActionRetry = <ThrowOnError extends boolean = false>(options: Options<JobActionRetryData, ThrowOnError>): RequestResult<JobActionRetryResponses, JobActionRetryErrors, ThrowOnError> => (options.client ?? client).post<JobActionRetryResponses, JobActionRetryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/jobs/actions/retry',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Terminate the given rate shop message
 */
export const jobActionTerminate = <ThrowOnError extends boolean = false>(options: Options<JobActionTerminateData, ThrowOnError>): RequestResult<JobActionTerminateResponses, JobActionTerminateErrors, ThrowOnError> => (options.client ?? client).post<JobActionTerminateResponses, JobActionTerminateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/jobs/actions/terminate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Return the status of the city
 */
export const locationGetStatus = <ThrowOnError extends boolean = false>(options: Options<LocationGetStatusData, ThrowOnError>): RequestResult<LocationGetStatusResponses, LocationGetStatusErrors, ThrowOnError> => (options.client ?? client).get<LocationGetStatusResponses, LocationGetStatusErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/locations/{id}/status',
    ...options
});

/**
 * Query multiple settings
 */
export const organizationLimitQuery = <ThrowOnError extends boolean = false>(options?: Options<OrganizationLimitQueryData, ThrowOnError>): RequestResult<OrganizationLimitQueryResponses, OrganizationLimitQueryErrors, ThrowOnError> => (options?.client ?? client).get<OrganizationLimitQueryResponses, OrganizationLimitQueryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/organization_limits',
    ...options
});

/**
 * Get settings
 */
export const organizationLimitGetSettings = <ThrowOnError extends boolean = false>(options: Options<OrganizationLimitGetSettingsData, ThrowOnError>): RequestResult<OrganizationLimitGetSettingsResponses, OrganizationLimitGetSettingsErrors, ThrowOnError> => (options.client ?? client).get<OrganizationLimitGetSettingsResponses, OrganizationLimitGetSettingsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/organization_limits/{id}',
    ...options
});

/**
 * Save settings
 */
export const organizationLimitSave = <ThrowOnError extends boolean = false>(options: Options<OrganizationLimitSaveData, ThrowOnError>): RequestResult<OrganizationLimitSaveResponses, OrganizationLimitSaveErrors, ThrowOnError> => (options.client ?? client).patch<OrganizationLimitSaveResponses, OrganizationLimitSaveErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/organization_limits/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Load the settings change log for an id
 */
export const organizationLimitGetChangeLog = <ThrowOnError extends boolean = false>(options: Options<OrganizationLimitGetChangeLogData, ThrowOnError>): RequestResult<OrganizationLimitGetChangeLogResponses, OrganizationLimitGetChangeLogErrors, ThrowOnError> => (options.client ?? client).get<OrganizationLimitGetChangeLogResponses, OrganizationLimitGetChangeLogErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/organization_limits/{id}/change_log',
    ...options
});

/**
 * Query multiple noun rows using the noun-specific request parameters.
 */
export const organizationQuery = <ThrowOnError extends boolean = false>(options?: Options<OrganizationQueryData, ThrowOnError>): RequestResult<OrganizationQueryResponses, OrganizationQueryErrors, ThrowOnError> => (options?.client ?? client).get<OrganizationQueryResponses, OrganizationQueryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/organizations',
    ...options
});

/**
 * Insert a single noun row.
 */
export const organizationInsert = <ThrowOnError extends boolean = false>(options: Options<OrganizationInsertData, ThrowOnError>): RequestResult<OrganizationInsertResponses, OrganizationInsertErrors, ThrowOnError> => (options.client ?? client).post<OrganizationInsertResponses, OrganizationInsertErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/organizations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Bulk-save multiple noun rows. Each noun has one or more identifiers in order to 'upsert' an existing document, starting with its id. See the noun's schema documentation.
 */
export const organizationActionBulkSave = <ThrowOnError extends boolean = false>(options: Options<OrganizationActionBulkSaveData, ThrowOnError>): RequestResult<OrganizationActionBulkSaveResponses, OrganizationActionBulkSaveErrors, ThrowOnError> => (options.client ?? client).patch<OrganizationActionBulkSaveResponses, OrganizationActionBulkSaveErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/organizations/actions/bulk_save',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create an organization and an assigned user
 */
export const organizationActionProvision = <ThrowOnError extends boolean = false>(options: Options<OrganizationActionProvisionData, ThrowOnError>): RequestResult<OrganizationActionProvisionResponses, OrganizationActionProvisionErrors, ThrowOnError> => (options.client ?? client).post<OrganizationActionProvisionResponses, OrganizationActionProvisionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/organizations/actions/provision',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Save one noun by natural identifer. Each noun has one or more identifiers in order to 'upsert' an existing document. See the noun's schema documentation.
 */
export const organizationActionSave = <ThrowOnError extends boolean = false>(options: Options<OrganizationActionSaveData, ThrowOnError>): RequestResult<OrganizationActionSaveResponses, OrganizationActionSaveErrors, ThrowOnError> => (options.client ?? client).patch<OrganizationActionSaveResponses, OrganizationActionSaveErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/organizations/actions/save',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Load a single noun by internal id
 */
export const organizationGet = <ThrowOnError extends boolean = false>(options: Options<OrganizationGetData, ThrowOnError>): RequestResult<OrganizationGetResponses, OrganizationGetErrors, ThrowOnError> => (options.client ?? client).get<OrganizationGetResponses, OrganizationGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/organizations/{id}',
    ...options
});

/**
 * Update a single noun row.
 */
export const organizationSave = <ThrowOnError extends boolean = false>(options: Options<OrganizationSaveData, ThrowOnError>): RequestResult<OrganizationSaveResponses, OrganizationSaveErrors, ThrowOnError> => (options.client ?? client).patch<OrganizationSaveResponses, OrganizationSaveErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/organizations/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Load the change log for a single noun by internal id
 */
export const organizationGetChangeLog = <ThrowOnError extends boolean = false>(options: Options<OrganizationGetChangeLogData, ThrowOnError>): RequestResult<OrganizationGetChangeLogResponses, OrganizationGetChangeLogErrors, ThrowOnError> => (options.client ?? client).get<OrganizationGetChangeLogResponses, OrganizationGetChangeLogErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/organizations/{id}/change_log',
    ...options
});

/**
 * Query many metadatas
 */
export const rateScrapeMetadataQuery = <ThrowOnError extends boolean = false>(options?: Options<RateScrapeMetadataQueryData, ThrowOnError>): RequestResult<RateScrapeMetadataQueryResponses, RateScrapeMetadataQueryErrors, ThrowOnError> => (options?.client ?? client).get<RateScrapeMetadataQueryResponses, RateScrapeMetadataQueryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/rate_scrape_metadatas',
    ...options
});

/**
 * Save many metadata.
 */
export const rateScrapeMetadataActionBulkSave = <ThrowOnError extends boolean = false>(options: Options<RateScrapeMetadataActionBulkSaveData, ThrowOnError>): RequestResult<RateScrapeMetadataActionBulkSaveResponses, RateScrapeMetadataActionBulkSaveErrors, ThrowOnError> => (options.client ?? client).patch<RateScrapeMetadataActionBulkSaveResponses, RateScrapeMetadataActionBulkSaveErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/rate_scrape_metadatas/actions/bulk_save',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Cached summary shopping metrics for hotel/sites
 */
export const rateScrapeMetadataActionCachedShoppingMetrics = <ThrowOnError extends boolean = false>(options: Options<RateScrapeMetadataActionCachedShoppingMetricsData, ThrowOnError>): RequestResult<RateScrapeMetadataActionCachedShoppingMetricsResponses, RateScrapeMetadataActionCachedShoppingMetricsErrors, ThrowOnError> => (options.client ?? client).get<RateScrapeMetadataActionCachedShoppingMetricsResponses, RateScrapeMetadataActionCachedShoppingMetricsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/rate_scrape_metadatas/actions/cached_shopping_metrics',
    ...options
});

/**
 * Query one metadata
 */
export const rateScrapeMetadataGet = <ThrowOnError extends boolean = false>(options: Options<RateScrapeMetadataGetData, ThrowOnError>): RequestResult<RateScrapeMetadataGetResponses, RateScrapeMetadataGetErrors, ThrowOnError> => (options.client ?? client).get<RateScrapeMetadataGetResponses, RateScrapeMetadataGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/rate_scrape_metadatas/{externalId}',
    ...options
});

/**
 * Save one metadata with options.
 */
export const rateScrapeMetadataSave = <ThrowOnError extends boolean = false>(options: Options<RateScrapeMetadataSaveData, ThrowOnError>): RequestResult<RateScrapeMetadataSaveResponses, RateScrapeMetadataSaveErrors, ThrowOnError> => (options.client ?? client).patch<RateScrapeMetadataSaveResponses, RateScrapeMetadataSaveErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/rate_scrape_metadatas/{externalId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Record a usage problem with a rate scrape metadata field
 */
export const rateScrapeMetadataActionAddProblem = <ThrowOnError extends boolean = false>(options: Options<RateScrapeMetadataActionAddProblemData, ThrowOnError>): RequestResult<RateScrapeMetadataActionAddProblemResponses, RateScrapeMetadataActionAddProblemErrors, ThrowOnError> => (options.client ?? client).patch<RateScrapeMetadataActionAddProblemResponses, RateScrapeMetadataActionAddProblemErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/rate_scrape_metadatas/{externalId}/actions/add_problem',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Clear all rate scrape metadata and start over, leaving data issues
 */
export const rateScrapeMetadataActionClear = <ThrowOnError extends boolean = false>(options: Options<RateScrapeMetadataActionClearData, ThrowOnError>): RequestResult<RateScrapeMetadataActionClearResponses, RateScrapeMetadataActionClearErrors, ThrowOnError> => (options.client ?? client).post<RateScrapeMetadataActionClearResponses, RateScrapeMetadataActionClearErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/rate_scrape_metadatas/{externalId}/actions/clear',
    ...options
});

/**
 * Copy hotel metadata to shared metadata
 */
export const rateScrapeMetadataActionPromote = <ThrowOnError extends boolean = false>(options: Options<RateScrapeMetadataActionPromoteData, ThrowOnError>): RequestResult<RateScrapeMetadataActionPromoteResponses, RateScrapeMetadataActionPromoteErrors, ThrowOnError> => (options.client ?? client).post<RateScrapeMetadataActionPromoteResponses, RateScrapeMetadataActionPromoteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/rate_scrape_metadatas/{externalId}/actions/promote',
    ...options
});

/**
 * Create metadata for a hotel from its booking engine shared metadata
 */
export const rateScrapeMetadataActionPropagateShared = <ThrowOnError extends boolean = false>(options: Options<RateScrapeMetadataActionPropagateSharedData, ThrowOnError>): RequestResult<RateScrapeMetadataActionPropagateSharedResponses, RateScrapeMetadataActionPropagateSharedErrors, ThrowOnError> => (options.client ?? client).post<RateScrapeMetadataActionPropagateSharedResponses, RateScrapeMetadataActionPropagateSharedErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/rate_scrape_metadatas/{externalId}/actions/propagate_shared',
    ...options
});

/**
 * Load the change log for a single metadata
 */
export const rateScrapeMetadataGetChangeLog = <ThrowOnError extends boolean = false>(options: Options<RateScrapeMetadataGetChangeLogData, ThrowOnError>): RequestResult<RateScrapeMetadataGetChangeLogResponses, RateScrapeMetadataGetChangeLogErrors, ThrowOnError> => (options.client ?? client).get<RateScrapeMetadataGetChangeLogResponses, RateScrapeMetadataGetChangeLogErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/rate_scrape_metadatas/{externalId}/change_log',
    ...options
});

/**
 * Query sessions.
 */
export const sessionQuery = <ThrowOnError extends boolean = false>(options?: Options<SessionQueryData, ThrowOnError>): RequestResult<SessionQueryResponses, SessionQueryErrors, ThrowOnError> => (options?.client ?? client).get<SessionQueryResponses, SessionQueryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/sessions',
    ...options
});

/**
 * Create a new session for the given user and for the given number of days. Delete any existing session for that user.
 */
export const sessionNewSession = <ThrowOnError extends boolean = false>(options: Options<SessionNewSessionData, ThrowOnError>): RequestResult<SessionNewSessionResponses, SessionNewSessionErrors, ThrowOnError> => (options.client ?? client).post<SessionNewSessionResponses, SessionNewSessionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/sessions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete the given session by id.
 */
export const sessionDelete = <ThrowOnError extends boolean = false>(options: Options<SessionDeleteData, ThrowOnError>): RequestResult<SessionDeleteResponses, SessionDeleteErrors, ThrowOnError> => (options.client ?? client).delete<SessionDeleteResponses, SessionDeleteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/sessions/{sessionId}',
    ...options
});

/**
 * Get one shared metadata
 */
export const sharedRateScrapeMetadataGet = <ThrowOnError extends boolean = false>(options: Options<SharedRateScrapeMetadataGetData, ThrowOnError>): RequestResult<SharedRateScrapeMetadataGetResponses, SharedRateScrapeMetadataGetErrors, ThrowOnError> => (options.client ?? client).get<SharedRateScrapeMetadataGetResponses, SharedRateScrapeMetadataGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/shared_rate_scrape_metadatas/{bookingEngine}',
    ...options
});

/**
 * Save one metadata
 */
export const sharedRateScrapeMetadataSave = <ThrowOnError extends boolean = false>(options: Options<SharedRateScrapeMetadataSaveData, ThrowOnError>): RequestResult<SharedRateScrapeMetadataSaveResponses, SharedRateScrapeMetadataSaveErrors, ThrowOnError> => (options.client ?? client).patch<SharedRateScrapeMetadataSaveResponses, SharedRateScrapeMetadataSaveErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/shared_rate_scrape_metadatas/{bookingEngine}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Propagate shared metadata to hotels that use that booking engine in shopping cities
 */
export const sharedRateScrapeMetadataActionPropagate = <ThrowOnError extends boolean = false>(options: Options<SharedRateScrapeMetadataActionPropagateData, ThrowOnError>): RequestResult<SharedRateScrapeMetadataActionPropagateResponses, SharedRateScrapeMetadataActionPropagateErrors, ThrowOnError> => (options.client ?? client).post<SharedRateScrapeMetadataActionPropagateResponses, SharedRateScrapeMetadataActionPropagateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/shared_rate_scrape_metadatas/{bookingEngine}/actions/propagate',
    ...options
});

/**
 * Return information about metadata set stats for the given booking engine
 */
export const sharedRateScrapeMetadataActionStats = <ThrowOnError extends boolean = false>(options: Options<SharedRateScrapeMetadataActionStatsData, ThrowOnError>): RequestResult<SharedRateScrapeMetadataActionStatsResponses, SharedRateScrapeMetadataActionStatsErrors, ThrowOnError> => (options.client ?? client).get<SharedRateScrapeMetadataActionStatsResponses, SharedRateScrapeMetadataActionStatsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/shared_rate_scrape_metadatas/{bookingEngine}/actions/stats',
    ...options
});

/**
 * Load the change log for a single shared metadata
 */
export const sharedRateScrapeMetadataGetChangeLog = <ThrowOnError extends boolean = false>(options: Options<SharedRateScrapeMetadataGetChangeLogData, ThrowOnError>): RequestResult<SharedRateScrapeMetadataGetChangeLogResponses, SharedRateScrapeMetadataGetChangeLogErrors, ThrowOnError> => (options.client ?? client).get<SharedRateScrapeMetadataGetChangeLogResponses, SharedRateScrapeMetadataGetChangeLogErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/shared_rate_scrape_metadatas/{bookingEngine}/change_log',
    ...options
});

/**
 * Retrieve all system values from cache
 */
export const systemValueActionGetCache = <ThrowOnError extends boolean = false>(options?: Options<SystemValueActionGetCacheData, ThrowOnError>): RequestResult<SystemValueActionGetCacheResponses, SystemValueActionGetCacheErrors, ThrowOnError> => (options?.client ?? client).get<SystemValueActionGetCacheResponses, SystemValueActionGetCacheErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/system_values/actions/get_cache',
    ...options
});

/**
 * Retrieve all system values from the database
 */
export const systemValueActionQueryAll = <ThrowOnError extends boolean = false>(options?: Options<SystemValueActionQueryAllData, ThrowOnError>): RequestResult<SystemValueActionQueryAllResponses, SystemValueActionQueryAllErrors, ThrowOnError> => (options?.client ?? client).get<SystemValueActionQueryAllResponses, SystemValueActionQueryAllErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/system_values/actions/query_all',
    ...options
});

/**
 * Reload cache
 */
export const systemValueActionReload = <ThrowOnError extends boolean = false>(options?: Options<SystemValueActionReloadData, ThrowOnError>): RequestResult<SystemValueActionReloadResponses, SystemValueActionReloadErrors, ThrowOnError> => (options?.client ?? client).post<SystemValueActionReloadResponses, SystemValueActionReloadErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/system_values/actions/reload',
    ...options
});

/**
 * Save a single value.
 */
export const systemValueSave = <ThrowOnError extends boolean = false>(options: Options<SystemValueSaveData, ThrowOnError>): RequestResult<SystemValueSaveResponses, SystemValueSaveErrors, ThrowOnError> => (options.client ?? client).patch<SystemValueSaveResponses, SystemValueSaveErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/system_values/{key}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Query multiple noun rows using the noun-specific request parameters.
 */
export const userQuery = <ThrowOnError extends boolean = false>(options?: Options<UserQueryData, ThrowOnError>): RequestResult<UserQueryResponses, UserQueryErrors, ThrowOnError> => (options?.client ?? client).get<UserQueryResponses, UserQueryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/users',
    ...options
});

/**
 * Load a single noun by internal id
 */
export const userGet = <ThrowOnError extends boolean = false>(options: Options<UserGetData, ThrowOnError>): RequestResult<UserGetResponses, UserGetErrors, ThrowOnError> => (options.client ?? client).get<UserGetResponses, UserGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/users/{id}',
    ...options
});

/**
 * Load the change log for a single noun by internal id
 */
export const userGetChangeLog = <ThrowOnError extends boolean = false>(options: Options<UserGetChangeLogData, ThrowOnError>): RequestResult<UserGetChangeLogResponses, UserGetChangeLogErrors, ThrowOnError> => (options.client ?? client).get<UserGetChangeLogResponses, UserGetChangeLogErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/users/{id}/change_log',
    ...options
});
